export default defineAppConfig({
  ui: {
    primary: 'indigo',
    gray: 'zinc',
  }
})